import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于51cg
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            了解51cg的故事与使命
          </p>
        </div>

        <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
          <div className="flex items-center gap-3 mb-6 pb-6 border-b border-background-200/60">
            <span className="text-4xl font-heading font-bold text-foreground-950 tracking-tight">
              51<span className="text-accent-500">cg</span>
            </span>
            <span className="text-sm text-foreground-500 bg-accent-100 text-accent-700 px-2 py-0.5 rounded font-medium">
              吃瓜第一站
            </span>
          </div>

          <div className="space-y-4">
            {aboutInfo.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}